import { gql } from '@apollo/client';

export default gql`
    query relationWorkspaceToTeamQuery($id: ID!) {
        result: workspace(id: $id) {
            id
            name
            teams {
                role
                team {
                    id
                    name
                }
            }
        }
    }
`;
